<template>
  <div class="page" v-loading="listLoading">
    <div style="display:flex;padding-bottom: 10px; overflow-x: auto;">
      <el-button :type="SelectedButton === -1 ? 'primary' : 'info'" size="mini" @click="getOwnProduct">自有商品</el-button>
      <el-button @click="getSupplierProduct(item, index)" :type="SelectedButton === index ? 'primary' : 'info'"
        size="mini" v-for="(item, index) in
      supplierList" :key="index">{{ item.value
      }}</el-button>
    </div>
    <!--    <div id="scroll">-->
    <!--      <el-button type="primary" size="medium" v-for="(item, index) in supplierList" :key="index">{{ item.value-->
    <!--        }}</el-button>-->
    <!--    </div>-->
    <!--    <el-scrollbar style="border:1px solid red;">-->
    <!--      <el-button type="primary" size="medium" v-for="(item, index) in supplierList" :key="index">{{ item.value-->
    <!--        }}</el-button>-->
    <!--    </el-scrollbar>-->
    <el-form @submit.native.prevent label-width="100px" class="mgt20">
      <el-row>
        <el-col :span="6">
          <el-form-item label="商品SpuId">
            <el-input v-model="Ids" placeholder="请输入商品Id" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品名称">
            <el-input v-model="Name" placeholder="请输入商品名称" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品品牌">
            <el-autocomplete class="w100" v-model="brandName" :fetch-suggestions="querySearchAsync" placeholder="请选择"
              @select="handleSelect" clearable @clear="clearBtn"></el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品型号">
            <el-input v-model="Model" placeholder="请输入型号" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="商品类型">
            <el-cascader class="w100" v-model="CategoryIds" :props="{ emitPath: false, checkStrictly: true }"
              :show-all-levels="false" :options="productNavTypeTreeList" placeholder="请选择类型" clearable></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创建时间">
            <el-date-picker v-model="valueTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker" class="w100">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <div class="flex">
              <el-button type="primary" @click="searchFun">查询</el-button>
              <el-button @click="resetFun">重置</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <div class="flex">
          <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
        </div>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table :data="tableList" highlight-current-row element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
      @selection-change="selectCurrentRow" style="width: 100%" border>
      <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
      <el-table-column prop="id" label="SpuId" width="100" align="center"></el-table-column>
      <el-table-column prop="code" label="商品编码" width="120" align="center"></el-table-column>
      <el-table-column prop="supplierName" label="供货商" width="120" align="center"></el-table-column>
      <el-table-column label="商品图片" width="150" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.imageUrl" width="120" alt="暂无" @click="handleLookBigPic(scope.row.imageUrl)" />
        </template>
      </el-table-column>
      <el-table-column prop="name" label="商品名称" align="center" min-width="300"></el-table-column>
      <el-table-column prop="categoryName" label="商品类型" width="120" align="center"></el-table-column>
      <el-table-column prop="brandName" label="商品品牌" width="120" align="center"></el-table-column>
      <el-table-column label="商品型号" prop="model" width="120" align="center"></el-table-column>
      <el-table-column prop="stock" label="库存总量" width="120" align="center"></el-table-column>
      <el-table-column prop="creationTime" label="创建时间" width="200" align="center"></el-table-column>
      <el-table-column prop="lastModificationTime" label="最近操作时间" width="200" align="center"></el-table-column>
      <el-table-column width="200" label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
            @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" v-if="isShowPage" layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange" @current-change="handleCurrentChange" :total="total"
      :page-sizes="[10, 20, 30, 40, 50, 100]"></el-pagination>
  </div>
</template>

<script>
import {
  ProductSkuGetManyList,
  GetProductList,
  ProductDelete,
  brandGetAll,
  CategoryGetTree,
  SupplierGetAll
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";
// import IScroll from 'iscroll/build/iscroll-probe'
import IScroll from 'iscroll/build/iscroll-probe'
export default {
  components: { Toolbar },
  data() {
    return {
      isShowPage: true,
      Ids: null,
      Name: null, //商品名称
      Code: null,
      Model: null, //商品型号
      CategoryIds: null, //商品类型
      BrandIds: null, //品牌
      BeginCreationTime: null,
      EndCreationTime: null,
      PageIndex: 1, //页码
      PageSize: 10, //页长
      valueTime: [],
      total: 0,
      listLoading: false,
      currentRow: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      brandName: '',
      tableList: [],
      productNavTypeTreeList: [],
      supplierList: [],
      SourceType: 0, // 0 自有  1 供应商
      SourceId: null,
      SelectedButton: -1,
      CurrentSourceId: null,
      CurrentSourceType: 0,
    };
  },
  created() {
    this.getProductNavTypeTree();
    this.getBrandList();
    this.getSupplierList();
  },
  mounted() {
    // const myScroll = new IScroll('#scroll', {
    //   //按照需求添加横向滚动的配置项
    // });
    //更新
    // console.log('myScroll',myScroll)
    // myScroll.refresh();

    this.getSpusOnSale();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
    }
  },
  methods: {
    getOwnProduct() {
      // console.log('自有')
      this.PageIndex = 1;
      this.PageSize = 10;
      this.SelectedButton = -1;
      this.CurrentSourceId = null;
      this.CurrentSourceType = 0;
      // this.SourceType = 0;
      // this.SourceId = null;
      this.getSpusOnSale();
    },
    getSupplierProduct(item, index) {
      this.SelectedButton = index;
      this.CurrentSourceId = item.id;
      this.CurrentSourceType = 1;
      // console.log('item', item)
      this.getSpusOnSale()
      // let that = this;
      // let para = {
      //   Ids: that.Ids,
      //   Name: that.Name, //商品名称
      //   Model: that.Model, //商品型号
      //   CategoryIds: that.CategoryIds, //商品类型
      //   BrandIds: that.BrandIds, //品牌
      //   BeginCreationTime: that.BeginCreationTime,
      //   EndCreationTime: that.EndCreationTime,
      //   SkipCount: (that.PageIndex - 1) * that.PageSize,
      //   MaxResultCount: that.PageSize,
      //   SourceType: 1,
      //   SourceId: item.id,
      // };
      // console.log(para); return;
      // this.listLoading = true;
      // GetProductList(para).then((res) => {
      //   if (res.data.success) {
      //     if (res.data.result.items) {
      //       res.data.result.items.forEach(item => {
      //         item.IsSort = false
      //       })
      //     }
      //     this.total = res.data.result.totalCount;
      //     let list = res.data.result.items || [];
      //     list.forEach((item) => {
      //       item.popoverVisible = false;
      //     });
      //     this.tableList = list;
      //     this.listLoading = false;
      //   } else {
      //     this.$message.error(res.data.msg)
      //   }
      // });
    },
    getSupplierList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.supplierName = key;
      }

      return new Promise((resolve, reject) => {
        SupplierGetAll(obj).then((res) => {
          this.isShowPage = true;
          // console.log('供应商列表', res);
          if (res.data.success) {
            this.supplierList = res.data.result.items.map((item) => {
              return {
                value: item.proSupplierName,
                id: item.id,
              };
            });
            // console.log('this.supplierList', this.supplierList)
            resolve(this.supplierList);
          } else {
            this.isShowPage = true;
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    addGoods() {
      this.$router.push(`/Product/AddEditSpu`)
    },
    deleteGoods(item, index, row) {
      let list = []
      list.push(row.id)
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.getSpusOnSale()
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    batchDelete() {
      if (!this.currentRow[0])
        return this.$message.error("请选择需要操作的商品");
      let list = this.currentRow.map((v) => {
        return v.id
      });
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getSpusOnSale()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.BrandIds = item.id;
    },
    clearBtn(val) {
      this.BrandIds = null
    },
    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({ parentId: 0 }).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    searchFun() {
      this.PageIndex = 1;
      this.getSpusOnSale();
    },
    handlePicker(e) {
      if (e == null) {
        this.valueTime = []
        this.BeginCreationTime = e[0];
        this.EndCreationTime = e[1];
      } else {
        this.BeginCreationTime = e[0];
        this.EndCreationTime = e[1];
      }
    },
    resetFun() {
      this.$nextTick(() => {
        this.isShowPage = false;
      })

      this.Ids = null;
      this.Name = null; //商品名称
      this.Model = null; //商品型号
      this.Supplier = null; //供应商
      this.CategoryIds = null; //商品类型
      this.BrandIds = null; //品牌
      this.PageIndex = 1; //页码
      this.PageSize = 10; //页长
      this.BeginCreationTime = null;
      this.EndCreationTime = null;
      this.brandName = ''
      this.valueTime = []
      this.Code = null
      this.SelectedButton = -1
      this.CurrentSourceType = 0
      this.CurrentSourceId = null;
      this.getSpusOnSale();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.getSpusOnSale();
    },
    handleSizeChange(e) {
      this.PageSize = e;
      this.getSpusOnSale();
    },
    //获取商品列表
    getSpusOnSale() {
      let that = this;
      let para = {
        Ids: that.Ids,
        Name: that.Name, //商品名称
        Model: that.Model, //商品型号
        CategoryIds: that.CategoryIds, //商品类型
        BrandIds: that.BrandIds, //品牌
        BeginCreationTime: that.BeginCreationTime,
        EndCreationTime: that.EndCreationTime,
        SkipCount: (that.PageIndex - 1) * that.PageSize,
        MaxResultCount: that.PageSize,
        SourceType: this.CurrentSourceType,
        SourceId: this.CurrentSourceId,
        Code: that.Code
      };
      // console.log('para', para)
      this.listLoading = true;
      GetProductList(para).then((res) => {
        setTimeout(() => {
          this.listLoading = false;
        }, 500)
        if (res.data.success) {
          if (res.data.result.items) {
            res.data.result.items.forEach(item => {
              item.IsSort = false
            })
          }
          this.total = res.data.result.totalCount;
          let list = res.data.result.items || [];
          list.forEach((item) => {
            item.popoverVisible = false;
          });
          this.tableList = list;
          this.$nextTick(() => {
            this.isShowPage = true;
          })
        } else {
          this.$message.error(res.data.msg)
        }
      });
    },
    handleEdit(item, index, row) {
      this.$router.push(`/Product/AddEditSpu?id=${row.id}`)
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path == "/Product/ComManagement/EditProduct") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>

<style scoped>
.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap !important;
  overflow-x: auto;
}

/deep/ .el-scrollbar__wrap {
  height: calc(100% + 17px);
}

::-webkit-scrollbar-track-piece {
  background-color: #fff;
  -webkit-border-radius: 0
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px
}

::-webkit-scrollbar-thumb {
  height: 50px;
  background-color: #b8b8b8;
  -webkit-border-radius: 6px;
  outline: 2px solid #fff;
  outline-offset: -2px;
  border: 2px solid #fff;
  filter: alpha(opacity=50);
  -moz-opacity: 0.5;
  -khtml-opacity: 0.5;
  opacity: 0.5
}

::-webkit-scrollbar-thumb:hover {
  height: 50px;
  background-color: #878987;
  -webkit-border-radius: 6px
}
</style>
